"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A Promise wrapper class allowing for resolving/rejecting the Promise outside the context of its constructor.
 *
 * @export
 * @class Deferred
 * @template TResolve The type used to resolve the promise.
 * @template TReject The type used to reject the promise. Defaults to any.
 * @link https://stackoverflow.com/a/34637436
 */
class Deferred {
    /**
     * Creates an instance of Deferred.
     */
    constructor() {
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    /**
     * Gets the Promise.
     *
     * @readonly
     * @type {Promise<TResolve>}
     */
    get promise() {
        return this._promise;
    }
    /**
     * Resolves the wrapped Promise.
     *
     * @param {(TResolve | PromiseLike<TResolve>)} response The argument to be resolved by the Promise.
     * @returns {*}  {void}
     */
    resolve(response) {
        if (!this._resolve) {
            return;
        }
        this._resolve(response);
    }
    /**
     *
     *
     * @param {TReject} [reason] The reason why the Promise rejected.
     * @returns {*}  {void}
     */
    reject(reason) {
        if (!this._reject) {
            return;
        }
        this._reject(reason);
    }
}
exports.Deferred = Deferred;
exports.UnregisterTimeoutInMilliseconds = 30000;
//# sourceMappingURL=Deferred.js.map